 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBADFRONT from '@/components/ebadfront'
 import PORTALISTAD_1 from '@/components/portalistad_1'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import DEDICATION from '@/components/dedication'
 import TOC from '@/components/toc'
 import PREFACE001 from '@/components/preface001'
 import PROLOGUE from '@/components/prologue'
 import CHAPTER001 from '@/components/chapter001'
 import CHAPTER002 from '@/components/chapter002'
 import CHAPTER003 from '@/components/chapter003'
 import CHAPTER004 from '@/components/chapter004'
 import CHAPTER005 from '@/components/chapter005'
 import CHAPTER006 from '@/components/chapter006'
 import CHAPTER007 from '@/components/chapter007'
 import CHAPTER008 from '@/components/chapter008'
 import CHAPTER009 from '@/components/chapter009'
 import CHAPTER010 from '@/components/chapter010'
 import LOVE_2 from '@/components/love_2'
 import PRE from '@/components/pre'
 import PRE1 from '@/components/pre1'
 import PRE2 from '@/components/pre2'
 import PRE3 from '@/components/pre3'
 import AUTHORBIO from '@/components/Authorbio'
 import COPYRIGHT from '@/components/copyright'
 import AUAD from '@/components/auad'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/preface001",
 			"name" : "preface001",
 			"component" : PREFACE001
 		},
 		{
 			"path" : "/prologue",
 			"name" : "prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/chapter001",
 			"name" : "chapter001",
 			"component" : CHAPTER001
 		},
 		{
 			"path" : "/chapter002",
 			"name" : "chapter002",
 			"component" : CHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js